import React, { useEffect, useRef } from 'react';
import './Testimonials.css';

const testimonialsData = [
  {
    avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&q=80',
    name: '李先生',
    time: '忠实顾客 8年',
    text: '从小吃到大的味道，汤头浓郁，面条筋道。每次来都要排队，但值得！'
  },
  {
    avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&q=80',
    name: '王女士',
    time: '游客',
    text: '在北京吃过最正宗的牛肉面，老板很热情，还会再来！'
  },
  {
    avatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=100&q=80',
    name: '张同学',
    time: '学生优惠',
    text: '环境很有特色，价格实惠。强烈推荐担担面，麻辣鲜香！'
  }
];

const Testimonials = () => {
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate-in');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -50px 0px' }
    );

    if (sectionRef.current) {
      const items = sectionRef.current.querySelectorAll('.testimonial-card');
      items.forEach((item, index) => {
        item.style.opacity = '0';
        item.style.transform = 'translateY(30px)';
        item.style.transition = `all 0.6s ease ${index * 0.1}s`;
        observer.observe(item);
      });
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section className="testimonials" ref={sectionRef}>
      <div className="testimonials-bg">
        <img src="https://images.unsplash.com/photo-1593267306258-7f0282e5229c?w=1920&q=80" alt="评价背景" />
      </div>
      <div className="container">
        <div className="section-header">
          <span className="section-label">顾客评价</span>
          <h2 className="section-title">口碑之选</h2>
          <div className="section-decor">
            <span></span>
            <span>◆</span>
            <span></span>
          </div>
        </div>
        <div className="testimonial-grid">
          {testimonialsData.map((item, index) => (
            <div key={index} className="testimonial-card">
              <div className="stars">★★★★★</div>
              <p className="review-text">"{item.text}"</p>
              <div className="reviewer">
                <img src={item.avatar} alt={item.name} className="avatar-img" />
                <div className="reviewer-info">
                  <span className="name">{item.name}</span>
                  <span className="time">{item.time}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
